module.exports = __webpack_public_path__ + "img/03.01a000c7.png";